import LabelProvider from "core/components/label/LabelProvider";

export default LabelProvider.create({

    OrganizationNotFound:{
        k: "organization.notfound.title",
        v: "Organization Not Found"
    },
    OrganizationNotfoundDescription:{
        k: "organization.notfound.description",
        v: ""
    },
    OrganizationUserCount:{
        k:"organizion.users",
        v:"${UserCount} Users",
        argNames:["UserCount"]
    }
});


// WEBPACK FOOTER //
// ./src/panels/organizationParticipant/OrganizationParticipant.labels.ts